import React from 'react';
import ProjectSidebarComponent from './ProjectSidebarComponent';
import { PageHeader } from '../../components';

const SewageTreatmentPlantsStps: React.FC = () => {
  return (
    <>
      <PageHeader customClass="bg-breadcrumb-wtp"  title="Sewage Treatment Plants (STPs)" breadcrumbs={[{ label: "Projects", path: "/projects" }]} />

      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s"
        style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
        <div className="container">
          <div className="row g-5">

            <div className="col-lg-8">
              <div className="row g-3 mb-5">
                <div className="col-md-12">
                  <img className="img-fluid" src="img/operationandmaintainance.jpg" alt="" />
                </div>
                
              </div>
              <h1 className="mb-4">Sewage Treatment Plants (STPs)</h1>
              <h5 className="text-primary mb-4">(MBBR / MBR / SBR Technologies)</h5>
              
              <h3 className="mb-4">Overview</h3>
              <p>Sewage Treatment Plants (STPs) are designed to treat domestic or institutional wastewater for safe disposal or reuse. At Wasser Technochem (India) Ltd., we provide STPs based on the latest biological technologies — MBBR (Moving Bed Biofilm Reactor), MBR (Membrane Bioreactor), and SBR (Sequential Batch Reactor) — ensuring reliable performance, compact footprint, and compliance with CPCB norms and NGT guidelines.</p>
              <p>Our STPs are ideal for residential complexes, government institutions, hotels, industries, and municipalities, where space and performance reliability are critical.</p>

              <h3 className="mb-4">1. MBBR – Moving Bed Biofilm Reactor</h3>
              
              <h4 className="mb-3">Technology Summary:</h4>
              <p>MBBR uses floating plastic carriers within the aeration tank to grow biofilms. These biofilms biodegrade organic matter efficiently without requiring activated sludge recycling.</p>
              
              <h4 className="mb-3">Applications:</h4>
              <p><i className="fa fa-industry text-primary me-2"></i>Industrial parks</p>
              <p><i className="fa fa-building text-primary me-2"></i>Housing societies</p>
              <p><i className="fa fa-city text-primary me-2"></i>Small municipalities</p>
              <p><i className="fa fa-chart-line text-primary me-2"></i>STPs with space or load fluctuations</p>

              <h4 className="mb-3">Key Features & Benefits:</h4>
              <p><i className="fa fa-check-circle text-success me-2"></i>Compact footprint and scalable design</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Resistant to shock loads and toxic inflows</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Minimal operator intervention</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Easy upgrade of existing ASP-based plants</p>

              <hr className="my-5" />

              <h3 className="mb-4">2. MBR – Membrane Bioreactor</h3>
              
              <h4 className="mb-3">Technology Summary:</h4>
              <p>MBR combines biological treatment with membrane filtration (UF/MF) in a single tank, delivering crystal-clear, reusable water without tertiary filtration.</p>
              
              <h4 className="mb-3">Applications:</h4>
              <p><i className="fa fa-hotel text-primary me-2"></i>Hotels and resorts</p>
              <p><i className="fa fa-plane text-primary me-2"></i>Airports and railway stations</p>
              <p><i className="fa fa-hospital text-primary me-2"></i>Hospitals and pharma facilities</p>
              <p><i className="fa fa-building text-primary me-2"></i>Premium residential and commercial buildings</p>

              <h4 className="mb-3">Key Features & Benefits:</h4>
              <p><i className="fa fa-check-circle text-success me-2"></i>High-quality effluent (&lt;10 mg/L BOD, &lt;5 NTU turbidity)</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Small footprint — ideal for retrofits or basements</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Completely odour-free, silent operation</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Suitable for direct reuse (toilets, landscaping, HVAC)</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Fully automatic operation with remote monitoring</p>

              <hr className="my-5" />

              <h3 className="mb-4">3. SBR – Sequential Batch Reactor</h3>
              
              <h4 className="mb-3">Technology Summary:</h4>
              <p>SBR is a fill-and-draw activated sludge process where all treatment steps — aeration, settling, and decanting — occur in the same tank sequentially, reducing footprint and energy usage.</p>
              
              <h4 className="mb-3">Applications:</h4>
              <p><i className="fa fa-city text-primary me-2"></i>Municipal STPs</p>
              <p><i className="fa fa-industry text-primary me-2"></i>Medium-to-large industries</p>
              <p><i className="fa fa-building text-primary me-2"></i>Smart cities and urban developments</p>

              <h4 className="mb-3">Key Features & Benefits:</h4>
              <p><i className="fa fa-check-circle text-success me-2"></i>No need for separate clarifier and aeration tanks</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Fully automated cycle-based control</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Flexible operation for varying load conditions</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Cost-effective for larger capacities</p>

              <hr className="my-5" />

              <h3 className="mb-4">Why WTIL?</h3>
              <p><i className="fa fa-star text-warning me-2"></i>Technology-neutral design: We suggest MBBR, MBR, or SBR based on your specific site needs.</p>
              <p><i className="fa fa-star text-warning me-2"></i>More than 50 STP installations and operations across India — from 1 KLD to 50 MLD.</p>
              <p><i className="fa fa-star text-warning me-2"></i>In-house engineering, electrical, and automation teams.</p>
              <p><i className="fa fa-star text-warning me-2"></i>Comprehensive AMC, O&M, and remote troubleshooting support.</p>
              <p className="mb-5"><i className="fa fa-star text-warning me-2"></i>Dedicated Team for on-site troubleshooting in O&Ms</p>
            </div>

            <div className="col-lg-4">
              <ProjectSidebarComponent />
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default SewageTreatmentPlantsStps;
